import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

import { useCommunityAdminContext } from './CommunityAdminContextProvider';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

const Notification = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: start;
  gap: 20px;
  color: var(--text-secondary);
`;

const Text = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
`;

const CommunityAdminActions = () => {
  const { form, selectedCompany, loading, handleCancel } = useCommunityAdminContext();

  const onSave = () => {
    form?.submit();
  };

  return (
    <Container>
      <Notification>
        <img style={{ height: 16 }} src={'/logos/logo-mobile.svg'} />
        <Text>
          <span>
            <span style={{ fontFamily: 'var(--font-bold)', color: 'var(--text-primary)' }}>Mystery shopping</span> is
            usually done on competitors of any communities being shopped for.
          </span>
          <span>This community might be included in mystery shopping based on its competitor status.</span>
        </Text>
      </Notification>
      <Actions>
        <Button
          style={{ width: 120, height: 40 }}
          type="primary"
          loading={loading}
          disabled={loading || !selectedCompany}
          onClick={onSave}
        >
          Save
        </Button>
        <Button style={{ width: 120, height: 40 }} disabled={loading} onClick={handleCancel}>
          Cancel
        </Button>
      </Actions>
    </Container>
  );
};

export default CommunityAdminActions;
